<template>
  <div class="aboutUs" >
    <p>{{ $t("aboutUs.title") }}</p>
    <p>{{ $t("aboutUs.keyWord") }}</p>
    <p class="aboutUs-h5">
      <span v-for="(item, index) in describe" :key="index">{{ item }}</span>
    </p>
    <p class="aboutUs-pc" v-for="(item, index) in describe" :key="index">
      {{ item }}
    </p>
  </div>
</template>
<script>
export default {
  computed: {
    describe() {
      return this.$t("aboutUs.describe");
    },
  },
};
</script>
<style lang="less" scoped>
.aboutUs {
  width: 1060px;
  margin: 60px auto;
  text-align: center;
  padding-top: 60px;
  box-sizing: border-box;
  margin-top: 0;
  p {
    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #000000;
    line-height: 35px;
  }
  p:nth-child(1) {
    font-size: 24px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #ff5200;
    line-height: 33px;
  }
  p:nth-child(2) {
    font-size: 40px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    color: #000000;
    line-height: 55px;
    margin: 15px 0;
  }
  .aboutUs-h5 {
    display: none;
  }
  .aboutUs-pc {
    display: block;
  }
}
@media screen and (max-width: 1080px) {
  .aboutUs {
    width: 108rem;
    margin: 6rem auto;
    text-align: center;
    padding: 0 5rem;
    box-sizing: border-box;
    p {
      font-size: 3.5rem;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #000000;
      line-height: 7rem;
    }
    p:nth-child(1) {
      font-size: 3rem;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #ff5200;
      line-height: 3rem;
    }
    p:nth-child(2) {
      font-size: 5.3rem;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #000000;
      line-height: 5.3rem;
      margin: 3rem 0;
    }
    .aboutUs-pc {
      display: none;
    }
    .aboutUs-h5 {
      display: block;
      text-align: left;
    }
  }
}
</style>